import { Component, OnInit } from '@angular/core';
import { AppConstants } from 'src/app/app.constants';
import packageinfo from '../../../../package.json';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent  {
  hrefLinks : string;
  public Version:string = packageinfo.version;
  constructor() { }

  onClickOpenEmail(){
    this.hrefLinks=AppConstants.webMasterAddress;
    window.location.href = this.hrefLinks;
  }
}
